import React from 'react';

import { firstName } from './clientDashboardJourney';

export type ClientDashboardProgressHeaderProps = {
  userName?: string;
  projectName?: string;
  companyName?: string;
  /** Before any capabilities are selected */
  setupPhase?: boolean;
  /** When true, headline reflects completed assessment / insights phase */
  insightsPhase?: boolean;
};

export function ClientDashboardProgressHeader({
  userName,
  projectName,
  companyName,
  setupPhase = false,
  insightsPhase = false,
}: ClientDashboardProgressHeaderProps) {
  const greeting = firstName(userName);
  const projectLine = [projectName, companyName].filter(Boolean).join(' · ');

  let title: string;
  let lead: string;

  if (setupPhase) {
    title = `Welcome, ${greeting}. Let's set up your assessment.`;
    lead =
      'Your dashboard fills in once the assessment is complete. Two steps get you there — pick the capabilities to focus on, then rate them.';
  } else if (insightsPhase) {
    title = `Your assessment progress, ${greeting}`;
    lead =
      'Explore scores, gaps, and recommendations from your evaluation. Expert review and your report follow next.';
  } else {
    title = `Nice work, ${greeting}. You're ready to assess.`;
    lead =
      'Your focus areas are set. Start the assessment to rate where each capability is today and where it needs to be.';
  }

  return (
    <header className="client-dash__progress-head">
      {projectLine ? (
        <p className="client-dash__progress-context">{projectLine}</p>
      ) : null}
      <h1 className="client-dash__progress-title">{title}</h1>
      <p className="client-dash__progress-lead">{lead}</p>
    </header>
  );
}

export default ClientDashboardProgressHeader;
